import axios from 'axios';

export const sportalokaClient = axios.create({
  baseURL: process.env.REACT_APP_CORE_SERIVE_API_URL ?? ''
});

// Auth
export const signinAdmin = async (body) => {
  const { email, password } = body;

  return await sportalokaClient.post('admin/auth/signin', { email, password });
};

export const inviteUser = async (body) => {
  const { email, type, fullname } = body;

  return await sportalokaClient.post('admin/auth/invite-user', {
    email,
    type,
    fullname
  });
};

export const withdrawBalance = async (body) => {
  return await sportalokaClient.post('withdrawl/withdraw-balance', body);
};

export const getTenantRequest = async (query) => {
  return await sportalokaClient.get('admin/tenant/requests?' + query);
};

export const getWithdrawlDetail = async (id) => {
  return await sportalokaClient.get('withdrawl/detail/' + id);
};

export const refreshToken = async (refreshToken, sessionId) => {
  if (!refreshToken) {
    throw Error('refresh token is not provided');
  }
  if (!sessionId) {
    throw Error('session id is not provided');
  }

  return await sportalokaClient.post('auth/refresh-token', {
    refresh_token: refreshToken,
    session_id: sessionId
  });
};

export const getTenantDetail = async () => {
  return await sportalokaClient.post('tenant/detail/');
};

export const getTenantBalance = async () => {
  return await sportalokaClient.get('tenant/balance/');
};

export const inviteTenantAdmin = async (body) => {
  const { email, fullname } = body;

  return await sportalokaClient.post('user/invite/tenant-admin', {
    email,
    fullname
  });
};

export const getIncome = async (query) => {
  return await sportalokaClient.get('transaction/tenant/income?' + query);
};

export const getTodayBookings = async () => {
  return await sportalokaClient.get('booking/tenant/today-bookings');
};

export const getCashflow = async (query) => {
  return await sportalokaClient.get('transaction/tenant/cashflow?' + query);
};

export const getExpense = async (query) => {
  return await sportalokaClient.get('transaction/tenant/expense?' + query);
};

export const processTenantRequest = async (id) => {
  return await sportalokaClient.post('admin/tenant/process/' + id);
};

export const rejectTenantRequest = async (id, notes) => {
  return await sportalokaClient.post('admin/tenant/reject/' + id, { notes });
};

export const approveTenantRequest = async (id) => {
  return await sportalokaClient.post('admin/tenant/approve/' + id);
};

export const getTenantRequestDetail = async (id) => {
  return await sportalokaClient.get('admin/tenant/request-detail/' + id);
};

export const changePassword = async (body) => {
  const { old_password, password } = body;

  return await sportalokaClient.post('auth/change-password', {
    old_password,
    password,
    provider: 'direct'
  });
};

export const forgotPassword = async (email) => {
  return await sportalokaClient.post('auth/forgot-password', {
    email,
    provider: 'direct',
    continueUrl: process.env.REACT_APP_CORE_SERIVE_API_URL ?? 'http://localhost:3007'
  });
};

export const signout = async () => {
  return await sportalokaClient.post('auth/signout');
};

export const createProvince = async (name) => {
  return await sportalokaClient.post('admin/province/create', { name });
};

export const addGuestCost = async (payload, guest_id) => {
  return await sportalokaClient.post('booking/tenant/guest-costs/add/' + guest_id, payload);
};

export const fetchGuestsCosts = async (booking_id) => {
  return await sportalokaClient.get('booking/tenant/guest-costs/get/' + booking_id);
};

export const updateProvince = async (id, name) => {
  return await sportalokaClient.post('admin/province/update/' + id, { name });
};

export const searchProvinces = async (query) => {
  return await sportalokaClient.get('province/search?' + query);
};

export const deleteProvince = async (id) => {
  return await sportalokaClient.post('admin/province/delete/' + id);
};

export const deletePromotion = async (id) => {
  return await sportalokaClient.post('promotion/delete/' + id);
};

export const updateReview = async (id, is_approved) => {
  return await sportalokaClient.post('tenant/update-review/', { review_id: id, is_approved });
};

export const deleteClosingSchedule = async (id) => {
  return await sportalokaClient.post('closing-schedule/delete/' + id);
};

export const closingScheduleChangeNotifStatus = async (id) => {
  return await sportalokaClient.post('closing-schedule/change-notif-status/' + id);
};

export const createCity = async (province_id, name) => {
  return await sportalokaClient.post('admin/city/create', {
    province_id,
    name
  });
};

export const updateCity = async (id, name, province_id) => {
  return await sportalokaClient.post('admin/city/update/' + id, {
    name,
    province_id
  });
};

export const searchCities = async (query) => {
  return await sportalokaClient.get('city/search?' + query);
};

export const deleteCity = async (id) => {
  return await sportalokaClient.post('admin/city/delete/' + id);
};

export const createFacility = async (icon, name) => {
  return await sportalokaClient.post('admin/facility/create', { icon, name });
};

export const updateFacility = async (id, name, icon) => {
  return await sportalokaClient.post('admin/facility/update/' + id, {
    name,
    icon
  });
};

export const searchFacilities = async (query) => {
  return await sportalokaClient.get('facility/search?' + query);
};

export const deleteFacility = async (id) => {
  return await sportalokaClient.post('admin/facility/delete/' + id);
};

export const updateTenant = async (payload) => {
  return await sportalokaClient.post('tenant/update', payload);
};

export const createPackage = async (payload) => {
  return await sportalokaClient.post('package/create', payload);
};

export const createBankAccount = async (payload) => {
  return await sportalokaClient.post('bank-account/create', payload);
};

export const getBankAccountDetail = async (id) => {
  return await sportalokaClient.get('bank-account/detail/' + id);
};

export const updateBankAccount = async (id, data) => {
  return await sportalokaClient.post('bank-account/update/' + id, data);
};

export const createPromotion = async (payload) => {
  return await sportalokaClient.post('promotion/create', payload);
};

export const createClosingSchedule = async (payload) => {
  return await sportalokaClient.post('closing-schedule/create', payload);
};

export const updatePackage = async (id, payload) => {
  return await sportalokaClient.post('package/update/' + id, payload);
};

export const updatePromotion = async (id, payload) => {
  return await sportalokaClient.post('promotion/update/' + id, payload);
};

export const updateClosingSchedule = async (id, payload) => {
  return await sportalokaClient.post('closing-schedule/update/' + id, payload);
};

export const changePackageStatus = async (id, val) => {
  return await sportalokaClient.post('package/update-status/' + id, { status: val });
};

export const getPacakgeDetail = async (id) => {
  return await sportalokaClient.get('package/detail/' + id);
};

export const getPromotionDetail = async (id) => {
  return await sportalokaClient.get('promotion/detail/' + id);
};

export const getBookingDetail = async (id) => {
  return await sportalokaClient.get('booking/tenant/detail/' + id);
};

export const approveBooking = async (id) => {
  return await sportalokaClient.post('booking/tenant/approve/' + id);
};

export const executeGuest = async (id) => {
  return await sportalokaClient.post('booking/tenant/guest-execution/' + id);
};

export const rescheduleGuest = async (id, date) => {
  return await sportalokaClient.post('booking/tenant/guest-reschedule/' + id, { date });
};

export const deleteGuestsCost = async (id) => {
  return await sportalokaClient.post('booking/tenant/guest-costs/delete/' + id);
};

export const rejectBooking = async (id, reason) => {
  return await sportalokaClient.post('booking/tenant/reject/' + id, { reason });
};

export const executeBooking = async (id, date, guests) => {
  return await sportalokaClient.post('booking/tenant/guest-execution/' + id, {
    date,
    guests
  });
};

export const rescheduleBooking = async (id, date) => {
  return await sportalokaClient.post('booking/tenant/reschedule/' + id, { date });
};

export const getBookingHistory = async (id) => {
  return await sportalokaClient.get('booking/tenant/history/' + id);
};

export const getClosingScheduleDetail = async (id) => {
  return await sportalokaClient.get('closing-schedule/detail/' + id);
};

export const searchPackages = async (query) => {
  return await sportalokaClient.get('package/search?' + query);
};

export const searchPromotions = async (query) => {
  return await sportalokaClient.get('promotion/search?' + query);
};

export const searchReviews = async (query) => {
  return await sportalokaClient.get('tenant/search-reviews?' + query);
};

export const searchNewReviews = async (query) => {
  return await sportalokaClient.get('tenant/search-new-reviews?' + query);
};

export const searchWithdrawls = async (query) => {
  return await sportalokaClient.get('withdrawl/search?' + query);
};

export const searchBankAccount = async () => {
  return await sportalokaClient.get('bank-account/get');
};

export const searchBookings = async (query) => {
  return await sportalokaClient.get('booking/tenant/search?' + query);
};

export const searchUsers = async (query) => {
  return await sportalokaClient.get('user/tenant/search?' + query);
};

export const changeUserStatus = async (id) => {
  return await sportalokaClient.post('user/tenant/update-status/' + id);
};

export const searchClosingSchedule = async (query) => {
  return await sportalokaClient.get('closing-schedule/search?' + query);
};

export const searchTenantPackages = async (query) => {
  return await sportalokaClient.get('package/tenant/search?' + query);
};

export const upload = async (formData) => {
  return await sportalokaClient.post('uploader/upload', formData);
};

export const searchTenantCosts = async (query) => {
  return await sportalokaClient.get('tenant/cost/search?' + query);
};

export const createTenantCost = async (payload) => {
  return await sportalokaClient.post('tenant/cost/create', payload);
};

export const getTenantCostDetail = async (id) => {
  return await sportalokaClient.get('tenant/cost/detail/' + id);
};

export const updateTenantCost = async (id, payload) => {
  return await sportalokaClient.patch('tenant/cost/' + id, payload);
};

export const deleteTenantCost = async (id) => {
  return await sportalokaClient.delete('tenant/cost/' + id);
};

export const deleteBankAccount = async (id) => {
  return await sportalokaClient.post('bank-account/delete/' + id);
};
